// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".print-only[data-v-bffef9fa]{display:none}.modal-horario-agendado .modal-content p[data-v-bffef9fa]{font-size:1.6em}@media print{body[data-v-bffef9fa],html[data-v-bffef9fa]{height:auto!important}body[data-v-bffef9fa]{overflow:hidden}.modal-actions[data-v-bffef9fa],.modal-title[data-v-bffef9fa]{display:none}.print-only[data-v-bffef9fa]{display:block!important}}", ""]);
// Exports
module.exports = exports;
